import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import App from "./App";
import PlumberGame from "./games/PlumberGame";
import BusinessGame from "./games/BusinessGame"
import ArtGame from "./games/ArtGame";
import LawLiteratureGame from "./games/LawLiteratureGame";
import ComputerScienceGame from "./games/ComputerScienceGame";
import BioGame from "./games/BioGame";
import MedicineGame from "./games/MedicineGame";

export default function Root() {
    return (
        <BrowserRouter>
            <Routes>
                <Route path="/" element={<App />} />
                <Route path="/games/Plumber" element={<PlumberGame />} />
                <Route path="/games/Welder" element={<PlumberGame />} />
                <Route path="/games/Mechanic" element={<PlumberGame />} />
                <Route path="/games/Eletrician" element={<PlumberGame />} />
                <Route path="/games/Business" element={<BusinessGame />} />
                <Route path="/games/Freelance-Art" element={<ArtGame />} />
                <Route path="/games/Law" element={<LawLiteratureGame />} />
                <Route path="/games/Literature-Research-Education" element={<LawLiteratureGame />} />
                <Route path="/games/Tech" element={<ComputerScienceGame />} />
                <Route path="/games/Biology-Chemistry" element={<BioGame />} />
                <Route path="/games/Medicine" element={<MedicineGame />} />
            </Routes>
        </BrowserRouter>
    );
}
